import { render, staticRenderFns } from "./DetailCustomerMetrics.vue?vue&type=template&id=51c9e51c&scoped=true"
import script from "./DetailCustomerMetrics.vue?vue&type=script&lang=js"
export * from "./DetailCustomerMetrics.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomerMetrics.vue?vue&type=style&index=0&id=51c9e51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9e51c",
  null
  
)

export default component.exports